import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { initI18n, storedLanguage } from './i18n';
import './styles/index.css';

// i18n must be initialised before the first render: `useTranslation` outside an
// initialised instance renders raw keys for one frame, which is exactly the
// flash of `nav.warehouse.map` nobody wants to see on a cold load.
initI18n(storedLanguage());
document.documentElement.lang = storedLanguage();

const container = document.getElementById('root');
if (!container) throw new Error('#root missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
